import FeeInput from './FeeInput';
import ProductInput from './ProductInput';
import RegularFeeInput from './RegularFeeInput';

export default {
  'veengu.fee': FeeInput as any,
  'veengu.product': ProductInput as any,
  'veengu.regularFee': RegularFeeInput as any,
};
